import { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Selectedlayer } from '../../models/layer.models';
import { Project } from '../../models/project.module';
import { Geometry } from '../../models/general.models';


@Injectable({
  providedIn: 'root'
})
export class MapCommunicatorService  {
  public mapCommunicator = new BehaviorSubject<string>('');
  public selectedAreas = new ReplaySubject<string[]>();
  public rectangleSelectedAreas = new ReplaySubject<string[]>();
  public excludedAreas = new ReplaySubject<string[]>();
  public setAllAreas = new ReplaySubject<boolean>();
  public layers = new Subject<Array<Selectedlayer>>();
  public updateMapAreas = new Subject<Boolean>();

  public currentProject = new Subject<Project>();
  public boundingBox = new Subject<number[]>();
  public geometryToFocus = new Subject<{ geometry: Geometry, center?: boolean }  >();
  public baseMap: string = 'topographic';

  constructor() {
  }
}

